// src/get-var.ts
function getVar(variable, fallback) {
  return `var(${variable}, ${fallback})`;
}

export {
  getVar
};
